module.exports = __webpack_public_path__ + "static/media/socialite.9ce2ef47.svg";